// @flow
import React from "react";
import { useSelector } from "react-redux";
import { isEmpty } from "ramda";
import {
  SelecaoCasasDecimais,
  SelecaoPeriodo,
  SelecaoAjusteDias,
  SelecaoIndices,
  SelecaoPeriodicidade,
} from "../configuracoes";
import { type ErrosSelecao } from "../../../model";
import {
  type GeradorMedidasSelecionadas,
  type State,
  getEdicaoMedida,
  getIndicesEBenchmarksPersonalizados,
  getIndicesSelecionados,
  getDataBaseSelecionadaAsString,
  gerarMedidasSelecionadasPorPeriodo,
  i18n,
  isModoSeries,
  analiseValorDaMedida,
} from "../../../state";

import { randomId } from "../../../util";

export const criaFuncaoValidacaoPontualDiarioComIndice = (
  state: State
) => (): ?ErrosSelecao => {
  const erros: ErrosSelecao = {};
  const { translate } = i18n(state);

  if (isEmpty(getIndicesSelecionados(state)))
    erros.indicesNaoSelecionados = translate(
      "configuracaoRelatorio.indices.nenhumSelecionado"
    );

  return isEmpty(erros) ? null : erros;
};

export const processarPontualDiarioComIndice: GeradorMedidasSelecionadas = (
  state,
  medidas
) => {
  const edicaoMedida = getEdicaoMedida(state);
  const dataBase = getDataBaseSelecionadaAsString(state);
  const indicesSelecionados = new Set(edicaoMedida.indices || []);
  const indices = getIndicesEBenchmarksPersonalizados(state)
    .map(indice => indice.nome)
    .filter(indice => indicesSelecionados.has(indice));
  const modoSeries = isModoSeries(state);

  if (modoSeries) {
    return gerarMedidasSelecionadasPorPeriodo(state, medidas).flatMap(
      medidaSelecionada => {
        const idGrupoMedidasSelecionadas = randomId();
        return indices.map(indice => ({
          ...medidaSelecionada,
          idGrupoMedidasSelecionadas:
            medidaSelecionada.idGrupoMedidasSelecionadas ||
            idGrupoMedidasSelecionadas,
          descricaoSelecao: "",
          indice,
          ...analiseValorDaMedida(medidaSelecionada, state),
        }));
      }
    );
  } else {
    return gerarMedidasSelecionadasPorPeriodo(state, medidas).flatMap(
      medidaSelecionada => {
        const idGrupoMedidasSelecionadas = randomId();
        return indices.map(indice => ({
          ...medidaSelecionada,
          idGrupoMedidasSelecionadas:
            medidaSelecionada.idGrupoMedidasSelecionadas ||
            idGrupoMedidasSelecionadas,
          descricaoSelecao: "",
          periodicidade: edicaoMedida.periodicidade,
          ajusteDias: edicaoMedida.ajusteDias,
          indice,
          dataBase: dataBase,
          ...analiseValorDaMedida(medidaSelecionada, state),
        }));
      }
    );
  }
};

const PontualDiario = () => {
  const modoSeries = useSelector(isModoSeries);

  if (modoSeries) {
    return (
      <>
        <div className="ConfiguracaoMedida--row">
          <SelecaoIndices selectedOptionsFirst />
        </div>

        <div className="ConfiguracaoMedida__horizontal-divider" />
        <div className="ConfiguracaoMedida--row">
          <SelecaoPeriodo exibirPeriodicidade={false} />
          <div className="ConfiguracaoMedida">
            <div className="ConfiguracaoMedida__box">
              <SelecaoPeriodicidade />
            </div>

            <div className="ConfiguracaoMedida__box">
              <SelecaoAjusteDias />
            </div>
          </div>
        </div>
      </>
    );
  } else {
    return (
      <div className="ConfiguracaoMedida--no-flex">
        <div className="ConfiguracaoMedida--row">
          <SelecaoIndices selectedOptionsFirst />
          <SelecaoCasasDecimais />
        </div>

        <div className="ConfiguracaoMedida__horizontal-divider" />
        <div className="ConfiguracaoMedida--row">
          <SelecaoPeriodo exibirPeriodicidade={false} />
          <div className="ConfiguracaoMedida">
            <div className="ConfiguracaoMedida__box">
              <SelecaoPeriodicidade />
            </div>

            <div className="ConfiguracaoMedida__box">
              <SelecaoAjusteDias />
            </div>
          </div>
        </div>
      </div>
    );
  }
};

export default PontualDiario;
